// extracted by mini-css-extract-plugin
export var childrenContainer = "_bd-0";